import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import defaultLoadingImg from "@/assets/content-check/loading.png";

const LoadingStyle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100vw;
	.loading-img {
		width: 50px;
		height: 50px;
		animation: loading 1s infinite linear;
	}
	.loading-text {
		color: #fff;
		margin-top: 14px;
	}
	.loading-text-en {
		color: #fff;
		margin-top: 32px;
		img {
			height: 60px !important;
		}
	}
	@keyframes loading {
		to {
			transform: rotate(360deg);
		}
	}
`;
const Loading = (props) => {
	const { loadingIcon, isChecking = false } = props;
	return (
		<LoadingStyle>
			<img className="loading-img" src={loadingIcon} />
			<div className={`${isChecking ? "loading-text-en" : "loading-text"}`}>
				{props.children}
			</div>
		</LoadingStyle>
	);
};
Loading.propTypes = {
	loadingIcon: PropTypes.string,
	isChecking: PropTypes.bool,
	children: PropTypes.node,
};
Loading.defaultProps = {
	loadingIcon: defaultLoadingImg,
};
export default React.memo(Loading);
